import "./NewLinks.css";
import { useEffect } from "react";

export default function NewLink({ redirectTo, text, selected }) {
  useEffect(() => {}, [selected]);
  return (
    <a
      className={selected ? "newLinks selected" : "newLinks"}
      href={redirectTo}
    >
      {text}
    </a>
  );
}
